export const model = {
    id: null,
    user_id: null,
    patient_id: null,
    conclusion_id: null,
    created_at: ''
};
